import { ServiceResponse, HttpStatuses } from '../types';
import { useState, useCallback } from 'react';

/**
 * Service hook
 * @param service
 */
export default function<TResponseSuccessBody, TResponseErrorBody>(
  service: () => Promise<
    ServiceResponse<TResponseSuccessBody, TResponseErrorBody>
  >
) {
  const [isRequestDone, setIsRequestDone] = useState(false);
  const [response, setResponse] = useState<
    ServiceResponse<TResponseSuccessBody, TResponseErrorBody>
  >();
  const send = useCallback(async () => {
    setIsRequestDone(false);
    setResponse(await service());
    setIsRequestDone(true);
  }, [service]);

  return {
    response,
    isRequestDone,
    send,
    success: response && response.status === HttpStatuses.success
  };
}
